import { LocalizationService } from '@abp/ng.core';
import { PredefinedWrapUpCodeId } from 'src/core/constants/predefined-wrap-up-code-id.constant';

const PREDEFINED_WRAP_UP_CODE_IDS = new Set<number>(Object.values(PredefinedWrapUpCodeId));

export function predefinedWrapUpCodeKey(name: string): string {
  return `Settings::WorkEnvironment:WrapupCodes:Predefined:${name.replace(/\s+/g, '')}`;
}

export function localizePredefinedWrapUpCodeName(
  localization: LocalizationService,
  name: string,
): string {
  return translatePredefinedWrapUpCodeName(key => localization.instant(key), name);
}

export function localizeWrapUpCodeName(
  localization: LocalizationService,
  wrapUpId: number,
  name: string,
): string {
  return translateWrapUpCodeName(key => localization.instant(key), wrapUpId, name);
}

/** Same as `localizeWrapUpCodeName`, for callers that hold a plain translate function. */
export function translateWrapUpCodeName(
  translate: (key: string) => string,
  wrapUpId: number,
  name: string,
): string {
  return PREDEFINED_WRAP_UP_CODE_IDS.has(wrapUpId) ? translatePredefinedWrapUpCodeName(translate, name) : name;
}

function translatePredefinedWrapUpCodeName(translate: (key: string) => string, name: string): string {
  const key = predefinedWrapUpCodeKey(name);
  const localized = translate(key);
  return localized === key ? name : localized;
}
